import React, { useEffect, useState } from 'react';
import IconButton from '@mui/material/IconButton';
import { Close } from '@mui/icons-material';
import './NotificationPopup.css';

const NotificationPopup = ({ open, title, body, onClose, duration = 10000 }) => {
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    let timer;
    if (open && duration > 0) {
      timer = setTimeout(() => {
        handleClose();
      }, duration);
    }
    return () => clearTimeout(timer);
  }, [open, duration]);

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      onClose();
      setIsClosing(false);
    }, 300); // Should match CSS transition time
  };

  if (!open) return null;

  return (
    <div className="notification-popup-container">
      <div className={`notification-popup-card ${isClosing ? 'closing' : ''}`}>
        <div className="notification-popup-close-btn">
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={handleClose}
            sx={{ padding: '4px' }}
          >
            <Close fontSize="small" />
          </IconButton>
        </div>
        {title && <span className="notification-popup-title">{title}</span>}
        {body && <p className="notification-popup-body">{body}</p>}
        
        {/* Auto-close Progress Bar */}
        <div className="notification-popup-progress-container">
          <div 
            className="notification-popup-progress-bar"
            style={{ animationDuration: `${duration}ms` }}
          />
        </div>
      </div>
    </div>
  );
};

export default NotificationPopup;
